import React from 'react'

const Checkbox = ({ field, handleChange,formData }) => {

  return (
    <div className={field.colunms}>
      <div className="form-group checkbox-group">
        <label className="checkbox-label">
          <input
            type={field?.type}
            name={field.name}
            checked={formData[field.name]}
            required={field.required}
            onChange={handleChange}
          />
          <span
            dangerouslySetInnerHTML={{ __html: field.label }}
          />
        </label>
      </div>
    </div>
  )
}

export default Checkbox;
